'use client';

import { PropsWithChildren, ReactNode, forwardRef } from 'react';
import classNames from 'classnames';
import { GridTypes } from './types';
import { useMobileDetect } from '../mobile-detect-context/mobile-detect-provider';
interface Props extends PropsWithChildren {
  showGridLoading?: boolean;
  showInfiniteLoading?: boolean;
  loadingComponent?: ReactNode;
  type: GridTypes;
}
export const Grid = forwardRef<HTMLDivElement, Props>(function Grid({
  loadingComponent,
  showGridLoading,
  showInfiniteLoading,
  type,
  children
}, ref) {
  const {
    isMobile
  } = useMobileDetect();
  const isLoading = showGridLoading || showInfiniteLoading;
  return <>
            <div className={classNames('grid grid-cols-2 lg:grid-cols-4 [&>div:not(:nth-child(2n))]:border-l lg:[&>div:not(:nth-child(4n))]:border-l [&>div]:border-b [&>div]:border-border-gray-light', {
      '[&>div:not(:nth-child(-n+2))]:pt-1.5 [&>div:not(:nth-last-child(-n+2))]:pb-1.5 [&>div]:odd:pl-2 [&>div]:even:pr-2': isMobile
    }, {
      '[&>div:nth-child(-n+4)]:pt-0 [&>div:nth-child(4n)]:pl-0 [&>div:nth-child(4n+1)]:pr-0 [&>div:nth-last-child(-n+4)]:pb-0 [&>div]:pb-3 [&>div]:pl-3 [&>div]:pr-3 [&>div]:pt-3': !isMobile,
      '[&>div]:odd:pl-3 [&>div]:even:pr-3': !isMobile && type === GridTypes.PLP,
      '[&>div]:odd:pl-1.5 [&>div]:even:pr-1.5': !isMobile && type === GridTypes.Favorite
    })}>
                {showGridLoading ? loadingComponent : children}

                {showInfiniteLoading && loadingComponent}
            </div>

            {!isLoading && <div ref={ref} className='h-[1px] w-full' />}
        </>;
});